import App from 'app/app.js';
import 'app/service/EventService.js';

function JobLoadFailedAction(EventService) {
  this.eventName = 'jobLoadFailed';

  this.dispatch = function (contentMap) {
    EventService.dispatch(this.eventName, contentMap);
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('JobLoadFailedAction', ['EventService', JobLoadFailedAction]);
